import { css } from 'styled-components'
import variables from '../../shared/styles/variables'
// import variables from '../../shared/styles/variables'

const nav = css`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;

  li {
    flex-basis: auto;
    font-size: 1.4rem ;
    position: relative;
    
    &::before{
      border-right: 1px solid ${variables.STEEL_GRAY};
      border-top: 1px solid ${variables.STEEL_GRAY};
      content: "";
      height: 5px;
      left: -13px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%) rotate(45deg);
      width: 5px;
    }
    
    &:first-child {
      &::before {
        content: none;
      }
    }
    
    &:nth-child(n+2) {
      margin-left: 20px ;
    }
  }
`

export const style = {
  nav
}